// extracted by mini-css-extract-plugin
export default {"cardContainer":"FileUploadContainer_cardContainer__iEiAV","leftSection":"FileUploadContainer_leftSection__kOL33","rightSection":"FileUploadContainer_rightSection__AnFmN"};